import { IntlShape } from 'react-intl';
import { ModuleHierachy } from 'src/app/common/module/types';
import { isPermitted } from 'src/app/common/utils';
import {
  AdminOpmAdPermissionType,
  AGENT_QUALIFICATION_DETAIL_REPORT_PATH,
  AGENT_QUALIFICATION_DETAIL_REPORT_TITLE,
  OPM_AD_AGENT_QUALIFICATION_DETAIL_REPORT_NAMESPACE,
  OPM_AD_BASE_PATH,
  OPM_AD_TITLE,
} from './constants';
import AgentQualificationDetailReportRoutes from './pages/AgentQualificationDetailReport/AgentQualificationDetailReportRoutes';

export const opmAdModuleConfig = (permissions: string[], intl: IntlShape): ModuleHierachy => {
  return {
    title: OPM_AD_TITLE,
    path: OPM_AD_BASE_PATH,
    icon: '/media/svg/icons/Communication/Chat1.svg',
    enableRead: isPermitted([AdminOpmAdPermissionType.OPM_AD_AGENT_QUALIFICATION_DETAIL_REPORT_READ], permissions),
    disableRoleControl: false,
    child: [
      {
        title: AGENT_QUALIFICATION_DETAIL_REPORT_TITLE,
        path: `${OPM_AD_BASE_PATH}${AGENT_QUALIFICATION_DETAIL_REPORT_PATH}`,
        namespace: OPM_AD_AGENT_QUALIFICATION_DETAIL_REPORT_NAMESPACE,
        component: AgentQualificationDetailReportRoutes,
        enableRead: isPermitted([AdminOpmAdPermissionType.OPM_AD_AGENT_QUALIFICATION_DETAIL_REPORT_READ], permissions),
        enableCreate: isPermitted(
          [AdminOpmAdPermissionType.OPM_AD_AGENT_QUALIFICATION_DETAIL_REPORT_CREATE],
          permissions,
        ),
        enableUpdate: isPermitted(
          [AdminOpmAdPermissionType.OPM_AD_AGENT_QUALIFICATION_DETAIL_REPORT_UPDATE],
          permissions,
        ),
      },
    ],
  };
};
